import { z } from "zod";
import { BaseFirestoreWStatusSchema } from "./firestore.schema";

// Schemas

export const SiteColorsSchema = z.object({
  primary: z.string(),
  secondary: z.string(),
  tertiary: z.string(),
  success: z.string(),
  error: z.string(),
  warning: z.string(),
  info: z.string(),
});

export const SiteSchema = BaseFirestoreWStatusSchema.extend({
  logo: z.string(),
  banner: z.string(),
  colorScheme: SiteColorsSchema,
});

export const PublicSiteSchema = SiteSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  logo: true,
  banner: true,
  colorScheme: true,
});

// DTOs

export const CreateSiteDtoSchema = SiteSchema.partial();

export const PutSiteDtoSchema = CreateSiteDtoSchema;

export const PatchSiteDtoSchema = CreateSiteDtoSchema;
